<template>
  <aw-drag
    :enable="edit"
    :drag-item="element"
    #default="{ dragHandle }"
    class="DocumentBlock -text bg-white"
    :class="{ DocumentHasPlaceholder: element.placeholder, isCommentOpened: isCommentOpened, DocumentHighlightSearch: $route.hash === '#el' + element.id }"
    :id="'el' + element.id"
  >
    <div class="DocumentElement -text">
      <div
        class="w-full bg-bc-blue flex flex-row justify-center space-x-2 p-4"
        v-if="element.locked && !isEveryElementLocked && !isPageLocked"
      >
        <aw-icon icon="lock" class="w-5 h-5 text-white " />
        <span class="text-white text-sm">{{ $t('Element is locked') }}</span>
      </div>
      
      <contenteditable-ck
        v-model="data.html"
        :contenteditable="edit"
        :alwaysSelectAll="'<p>' + this.$t('Enter description here...') + '</p>'"
        @updated="updated = 'html'"
        :auto-focus="!element.id"
      />

      <!-- comments -->
      <document-comment
        v-if="bcDocumentStore.document.allow_comments"
        v-model="element.comments"
        :element="element"
        :document="bcDocumentStore.document"
        @comment-toggle="resolveZindexOnParent"
      />

      <!-- panel s moznosti noveho elementu -->
      <document-hot-action
        :parent="parent"
        :page="page"
        :index="index + 1"
        v-if="edit && !isLastOnPage"
      />
    </div>
    <div class="DocumentBlock__PanelRight -text">
      <span
        ref="DocumentCircle"
        class="DocumentCircle mr-2.5 sm:mr-3.5"
        :class="{
          'DocumentCircle--active': bcSelectedStore.selected.has(element.id)
        }"
        :data-item-index="element.root_rank"
        @click.prevent.stop="bcSelectedStore.select(
          element, 
          {
            isRecursive: true,
            isShift: $event.shiftKey,
            isDocument: true,
            itemIndex: element.root_rank,
          }
        )"
      ></span>
      <span
        class="cursor-move text-gray-400 hover:text-gray-500"
        v-if="edit"
        :ref="dragHandle"
      >
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
        <aw-icon icon="dots" class="w-4 h-4 -mx-1 "></aw-icon>
      </span>
    </div>
  </aw-drag>
</template>

<script>
import BaseElement from '../../mixins/BaseElement'
import Selected from '../../mixins/Selected'

export default {
  mixins: [
    BaseElement,
    Selected,
  ],
  mounted() {
    this.assignItemToSelectBtn('DocumentCircle', this.element)
  },
}
</script>

<style lang="scss">
.DocumentElement.-text .-text-content {
  ul {
    @apply my-2;

    li {
      @apply list-disc pl-0 ml-8 list-outside;
    }
  }

  ol {
    @apply my-2;

    li {
      @apply list-decimal pl-0 ml-8 list-outside;
    }
  }

  a {
    @apply text-bc-blue hover:underline no-underline;
  }

  mark.red-pen
  {
    @apply text-red-600 bg-white;
  }

  h3 {
    @apply text-lg;
  }

  h4 {
    @apply text-base;
  }

  hr {
    margin: 15px 0;
    height: 4px;
    background: #dedede;
    border: 0;
  }

  blockquote {
    overflow: hidden;
    padding-right: 1.5em;
    padding-left: 1.5em;
    margin-left: 0;
    margin-right: 0;
    font-style: italic;
    border-left: 5px solid #ccc;
  }

  mark {
    color: inherit;
  }

  .todo-list {
    list-style: none;

    li {
      margin-bottom: 5px;
      list-style-type: unset;

      label {
        >input {
          -webkit-appearance: none;
          display: inline-block;
          position: relative;
          width: 1rem;
          height: 1rem;
          vertical-align: middle;
          border: 0;
          left: -25px;
          margin-right: -15px;
          right: 0;
          margin-left: 0;

          &:before {
            display: block;
            position: absolute;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            content: "";
            width: 100%;
            height: 100%;
            border: 1px solid #333;
            border-radius: 2px;
            -webkit-transition: background .25s ease-in-out, border .25s ease-in-out, -webkit-box-shadow .25s ease-in-out;
            transition: background .25s ease-in-out, border .25s ease-in-out, -webkit-box-shadow .25s ease-in-out;
            transition: box-shadow .25s ease-in-out, background .25s ease-in-out, border .25s ease-in-out;
            transition: box-shadow .25s ease-in-out, background .25s ease-in-out, border .25s ease-in-out, -webkit-box-shadow .25s ease-in-out;
            background-color: unset;
          }

          &:after {
            display: block;
            position: absolute;
            -webkit-box-sizing: content-box;
            box-sizing: content-box;
            pointer-events: none;
            content: "";
            left: calc(var(--ck-todo-list-checkmark-size) / 3);
            top: calc(var(--ck-todo-list-checkmark-size) / 5.3);
            width: calc(var(--ck-todo-list-checkmark-size) / 5.3);
            height: calc(var(--ck-todo-list-checkmark-size) / 2.6);
            border-left: 0 solid rgba(0, 0, 0, 0);
            border-bottom: calc(var(--ck-todo-list-checkmark-size) / 8) solid rgba(0, 0, 0, 0);
            border-right: calc(var(--ck-todo-list-checkmark-size) / 8) solid rgba(0, 0, 0, 0);
            border-top: 0 solid rgba(0, 0, 0, 0);
            -webkit-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
          }
        }
      }
    }
  }

  pre {
    padding: 1em;
    color: #353535;
    background: hsla(0, 0%, 78%, .3);
    border: 1px solid #c4c4c4;
    border-radius: 2px;
    text-align: left;
    direction: ltr;
    -moz-tab-size: 4;
    -o-tab-size: 4;
    tab-size: 4;
    white-space: pre-wrap;
    font-style: normal;
    min-width: unset;

    code {
      background: unset;
      padding: 0;
      border-radius: 0;
    }

    &[data-language]:after {
      top: -1px;
      right: 10px;
      background: #757575;
      font-size: 10px;
      font-family: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;
      line-height: 16px;
      padding: 0.6rem 0.8rem;
      color: #fff;
      white-space: nowrap;
    }
  }
}

.DocumentElement.-text:not(:has(.bc-ck-editor)) {
  .todo-list {
    li {
      label {
        pointer-events: none;
      }
    }
  }
}

.ck.ck-balloon-panel {
  max-width: calc(100vw - 40px);

  @screen sm {
    max-width: calc(100vw - 80px);
  }

  @screen md {
    max-width: 600px;
  }
}
</style>
